import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faLink } from "@fortawesome/free-solid-svg-icons";

import "./styles/project.css";

const Project = (props) => {
  const { logo, title, description, linkText, link } = props;

  return (
    <>
      <div className="project">
        <a href={link} target="_blank">
          <div className="project-container">
            <div className="project-head">
              <h3 className="project-title">{title}</h3>
              <div className="project-logo">
                <img src={logo} alt="logo" />
              </div>
            </div>
            <p className="project-description">{description}</p>
            <div className="project-link">
              <div className="project-link-icon">
                <FontAwesomeIcon icon={faLink} />
              </div>

              <div className="project-link-text">{linkText}</div>
            </div>
          </div>
        </a>
      </div>
    </>
  );
};

export default Project;
